import type { AppRouteOwnership } from '@gonfalon/router/generated/routeInfo';

export const appRouteOwnership: AppRouteOwnership = {
  '/': 'team-foundation',
  '/*': 'team-foundation',
  '/confirm-auth/:deviceCode': 'team-enterprise',
  '/github-connect': 'team-o11y',
  '/foundation-cost-calculator': 'team-foundation',
  '/insights': 'team-enterprise',
  '/launchlitely': 'team-experimentation',
  '/launchlitely/:projectKey': 'team-experimentation',
  '/review/:owner/:repository/pull/:pullNumber': 'team-guardian-releases',
  '/product-analytics/integrations/:warehouseId': 'team-product-analytics',
  '/internal/new-hires': 'team-foundation',
  '/profile': 'team-enterprise',
  '/projects/:projectKey': 'team-foundation',
  '/projects/:projectKey/agentcontrol': 'team-foundation',
  '/projects/:projectKey/agentcontrol-welcome': 'team-ai-agents',
  '/projects/:projectKey/agentcontrol-welcome/setup-sdk': 'team-ai-agents',
  '/projects/:projectKey/ai-configs': 'team-ai-agents',
  '/projects/:projectKey/ai-configs/:configKey': 'team-ai-agents',
  '/projects/:projectKey/ai-configs/:configKey/monitoring': 'team-ai-agents',
  '/projects/:projectKey/ai-configs/:configKey/playground': 'team-ai-agents',
  '/projects/:projectKey/ai-configs/:configKey/targeting': 'team-ai-agents',
  '/projects/:projectKey/ai-configs/:configKey/targeting/pending-changes': 'team-ai-agents',
  '/projects/:projectKey/ai-configs/:configKey/variations': 'team-ai-agents',
  '/projects/:projectKey/ai-configs/:configKey/variations/:variationKey': 'team-ai-agents',
  '/projects/:projectKey/ai-configs/new': 'team-ai-agents',
  '/projects/:projectKey/ai-configs/model-configs': 'team-ai-agents',
  '/projects/:projectKey/ai-configs/model-configs/:configKey': 'team-ai-agents',
  '/projects/:projectKey/ai-configs/prompt-snippets': 'team-ai-agents',
  '/projects/:projectKey/ai-configs/prompt-snippets/:snippetKey': 'team-ai-agents',
  '/projects/:projectKey/ai-monitoring': 'team-ai-agents',
  '/projects/:projectKey/ai-monitoring/trends': 'team-ai-agents',
  '/projects/:projectKey/ai-library': 'team-ai-agents',
  '/projects/:projectKey/ai-library/models': 'team-ai-agents',
  '/projects/:projectKey/ai-library/models/:configKey': 'team-ai-agents',
  '/projects/:projectKey/settings/model-configs': 'team-ai-agents',
  '/projects/:projectKey/settings/model-configs/:configKey': 'team-ai-agents',
  '/projects/:projectKey/ai-library/tools': 'team-ai-agents',
  '/projects/:projectKey/ai-library/tool/:toolKey': 'team-ai-agents',
  '/projects/:projectKey/ai': 'team-ai-agents',
  '/projects/:projectKey/ai/coding-agents': 'team-ai-agents',
  '/projects/:projectKey/ai/graphs': 'team-ai-agents',
  '/projects/:projectKey/ai/graphs/:graphKey': 'team-ai-agents',
  '/projects/:projectKey/ai/optimize-agent': 'team-ai-agents',
  '/projects/:projectKey/ai/optimize-agent/new': 'team-ai-agents',
  '/projects/:projectKey/ai/optimize-agent/:optimizationId': 'team-ai-agents',
  '/projects/:projectKey/ai/optimize-agent/:optimizationId/configuration': 'team-ai-agents',
  '/projects/:projectKey/ai/optimize-agent/:optimizationId/runs': 'team-ai-agents',
  '/projects/:projectKey/ai/optimize-agent/:optimizationId/runs/:runId': 'team-ai-agents',
  '/projects/:projectKey/ai/evaluation': 'team-ai-evals',
  '/projects/:projectKey/ai/playgrounds': 'team-ai-evals',
  '/projects/:projectKey/ai/playgrounds/active': 'team-ai-evals',
  '/projects/:projectKey/ai/playgrounds/archived': 'team-ai-evals',
  '/projects/:projectKey/ai/playgrounds/:evaluationId': 'team-ai-evals',
  '/projects/:projectKey/ai/evaluations': 'team-ai-evals',
  '/projects/:projectKey/ai/evaluations/:evaluationId/runs/:runId': 'team-ai-evals',
  '/projects/:projectKey/ai-library/skills': 'team-ai-agents',
  '/projects/:projectKey/ai-library/skills/:skillKey': 'team-ai-agents',
  '/projects/:projectKey/ai-library/snippets': 'team-ai-agents',
  '/projects/:projectKey/ai-library/snippets/new': 'team-ai-agents',
  '/projects/:projectKey/ai-library/snippets/:snippetKey': 'team-ai-agents',
  '/projects/:projectKey/ai-library/judge-templates': 'team-ai-evals',
  '/projects/:projectKey/ai-library/judge-templates/:templateKey': 'team-ai-evals',
  '/projects/:projectKey/ai-library/datasets': 'team-ai-evals',
  '/projects/:projectKey/ai-library/datasets/:datasetKey': 'team-ai-evals',
  '/projects/:projectKey/alerts': 'team-o11y',
  '/projects/:projectKey/alerts/new': 'team-o11y',
  '/projects/:projectKey/alerts/:alertId': 'team-o11y',
  '/projects/:projectKey/alerts/:alertId/edit': 'team-o11y',
  '/projects/:projectKey/approvals': 'team-enterprise',
  '/projects/:projectKey/approvals/:approvalRequestId': 'team-enterprise',
  '/projects/:projectKey/audit': 'team-enterprise',
  '/projects/:projectKey/audit/:auditId/*': 'team-enterprise',
  '/projects/:projectKey/compare': 'team-foundation',
  '/projects/:projectKey/compare/:environmentPair': 'team-foundation',
  '/projects/:projectKey/compare/:environmentPair/flags/:flagKey': 'team-foundation',
  '/projects/:projectKey/contexts': 'team-foundation',
  '/projects/:projectKey/contexts/instances/:instanceId': 'team-foundation',
  '/projects/:projectKey/contexts/kinds': 'team-foundation',
  '/projects/:projectKey/contexts/kinds/:kind/instances/:key': 'team-foundation',
  '/projects/:projectKey/dashboards': 'team-o11y',
  '/projects/:projectKey/dashboards/new': 'team-o11y',
  '/projects/:projectKey/dashboards/:dashboardId': 'team-o11y',
  '/projects/:projectKey/dashboards/:dashboardId/new': 'team-o11y',
  '/projects/:projectKey/dashboards/:dashboardId/:graphId': 'team-o11y',
  '/projects/:projectKey/dashboards/:dashboardId/:graphId/edit': 'team-o11y',
  '/projects/:projectKey/errors': 'team-o11y',
  '/projects/:projectKey/errors/:issueId': 'team-o11y',
  '/projects/:projectKey/errors/:issueId/instances': 'team-o11y',
  '/projects/:projectKey/errors/:issueId/instances/:instanceId': 'team-o11y',
  '/projects/:projectKey/experiments': 'team-experimentation',
  '/projects/:projectKey/experiments/new': 'team-experimentation',
  '/projects/:projectKey/experiments/:experimentId/details': 'team-experimentation',
  '/projects/:projectKey/experiments/:experimentKey': 'team-experimentation',
  '/projects/:projectKey/experiments/:experimentKey/analytics': 'team-experimentation',
  '/projects/:projectKey/experiments/:experimentKey/exposures': 'team-experimentation',
  '/projects/:projectKey/experiments/:experimentKey/design': 'team-experimentation',
  '/projects/:projectKey/experiments/:experimentKey/design/pending-changes': 'team-experimentation',
  '/projects/:projectKey/experiments/:experimentKey/iterations': 'team-experimentation',
  '/projects/:projectKey/experiments/:experimentKey/iterations/:iterationId': 'team-experimentation',
  '/projects/:projectKey/experiments/:experimentKey/results': 'team-experimentation',
  '/projects/:projectKey/experiments/:experimentKey/results/pending-changes': 'team-experimentation',
  '/projects/:projectKey/experiments/:experimentKey/download-pdf': 'team-experimentation',
  '/projects/:projectKey/experiments/:experimentKey/traffic': 'team-experimentation',
  '/projects/:projectKey/multi-armed-bandits': 'team-experimentation',
  '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey': 'team-experimentation',
  '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/design': 'team-experimentation',
  '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/exposures': 'team-experimentation',
  '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/results': 'team-experimentation',
  '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/iterations': 'team-experimentation',
  '/projects/:projectKey/multi-armed-bandits/:multiArmedBanditKey/iterations/:iterationId': 'team-experimentation',
  '/projects/:projectKey/multi-armed-bandits/new': 'team-experimentation',
  '/projects/:projectKey/flags': 'team-foundation',
  '/projects/:projectKey/flags/:flagKey': 'team-foundation',
  '/projects/:projectKey/flags/:flagKey/add-to-code': 'team-enterprise',
  // Renders the same <FlagAddToCode /> as /add-to-code above, but owned by Foundation: this Code tab
  // and its not-in-code lifecycle are Foundation's v2 add-to-code work. The split from the legacy
  // /add-to-code route (team-enterprise) is deliberate.
  '/projects/:projectKey/flags/:flagKey/code': 'team-foundation',
  '/projects/:projectKey/flags/:flagKey/approvals/:approvalRequestId': 'team-enterprise',
  '/projects/:projectKey/flags/:flagKey/code-refs': 'team-enterprise',
  '/projects/:projectKey/flags/:flagKey/environment-overview': 'team-foundation',
  //settings for data export, rollout salts & triggers
  '/projects/:projectKey/flags/:flagKey/environments': 'team-foundation',
  //rule exclusion settings
  '/projects/:projectKey/flags/:flagKey/environments/exclude-rules': 'team-experimentation',
  '/projects/:projectKey/flags/:flagKey/experiments/*': 'team-experimentation',
  '/projects/:projectKey/flags/:flagKey/history': 'team-foundation',
  '/projects/:projectKey/flags/:flagKey/history/:auditId/*': 'team-foundation',
  //redirects to monitoring tab
  '/projects/:projectKey/flags/:flagKey/insights': 'team-guardian-monitoring',
  //redirects to flag targeting tab
  '/projects/:projectKey/flags/:flagKey/links': 'team-foundation',
  '/projects/:projectKey/flags/:flagKey/monitoring': 'team-guardian-monitoring',
  '/projects/:projectKey/flags/:flagKey/feedback': 'team-guardian-monitoring',
  '/projects/:projectKey/flags/:flagKey/audience': 'team-guardian-releases',
  '/projects/:projectKey/flags/:flagKey/overview': 'team-guardian-releases',
  '/projects/:projectKey/flags/:flagKey/settings': 'team-foundation',
  '/projects/:projectKey/flags/:flagKey/settings/archive': 'team-foundation',
  '/projects/:projectKey/flags/:flagKey/settings/deprecate': 'team-foundation',
  '/projects/:projectKey/flags/:flagKey/targeting': 'team-foundation',
  '/projects/:projectKey/flags/:flagKey/targeting/conflicts/:conflictIndex': 'team-enterprise',
  '/projects/:projectKey/flags/:flagKey/targeting/exclude-rules': 'team-experimentation',
  '/projects/:projectKey/flags/:flagKey/targeting/pending-changes': 'team-enterprise',
  '/projects/:projectKey/flags/:flagKey/targeting/pending-changes/:pendingId': 'team-enterprise',
  '/projects/:projectKey/flags/:flagKey/targeting/expiring-targets': 'team-foundation',
  '/projects/:projectKey/flags/:flagKey/targeting/expiring-targets/:expiringId': 'team-foundation',
  '/projects/:projectKey/flags/:flagKey/variations': 'team-foundation',
  '/projects/:projectKey/flags/:flagKey/variations/conflicts/:conflictIndex': 'team-enterprise',
  '/projects/:projectKey/flags/:flagKey/variations/pending-changes': 'team-enterprise',
  '/projects/:projectKey/flags/:flagKey/variations/pending-changes/:pendingId': 'team-enterprise',
  '/projects/:projectKey/flags/:flagKey/workflows': 'team-enterprise',
  '/projects/:projectKey/flags/:flagKey/workflows/:workflowId': 'team-enterprise',
  '/projects/:projectKey/flags/:flagKey/workflows/new': 'team-enterprise',
  '/projects/:projectKey/flags/new': 'team-foundation',
  //redirects to /projects/:projectKey/flags/new
  '/projects/:projectKey/flags/connect': 'team-foundation',
  '/projects/:projectKey/factory/release-coordinator': 'team-guardian-releases',
  '/projects/:projectKey/guarded-rollouts': 'team-guardian-releases',
  '/projects/:projectKey/holdouts': 'team-experimentation',
  '/projects/:projectKey/holdouts/new': 'team-experimentation',
  '/projects/:projectKey/holdouts/:holdoutKey': 'team-experimentation',
  '/projects/:projectKey/holdouts/:holdoutKey/details': 'team-experimentation',
  '/projects/:projectKey/holdouts/:holdoutKey/design': 'team-experimentation',
  '/projects/:projectKey/home': 'team-foundation',
  '/projects/:projectKey/sdk-setup': 'team-foundation',
  '/projects/:projectKey/live': 'team-foundation',
  '/projects/:projectKey/live/flags/:flagKey': 'team-foundation',
  '/projects/:projectKey/logs': 'team-o11y',
  '/projects/:projectKey/observability-metrics': 'team-o11y',
  '/projects/:projectKey/metrics': 'team-agent-platform',
  '/projects/:projectKey/metrics/:metricKey/details': 'team-agent-platform',
  '/projects/:projectKey/metrics/groups/:metricGroupKey/details': 'team-agent-platform',
  '/projects/:projectKey/metrics/new': 'team-agent-platform',
  '/projects/:projectKey/metrics/groups': 'team-agent-platform',
  '/projects/:projectKey/metrics/groups/new': 'team-agent-platform',
  '/projects/:projectKey/observe': 'team-agent-platform',
  '/projects/:projectKey/observe/new-metric': 'team-agent-platform',
  '/projects/:projectKey/observe/expand/:dataSourceKey/:eventKind/:eventKey': 'team-agent-platform',
  '/projects/:projectKey/releases': 'team-enterprise',
  '/projects/:projectKey/releases/:releasePipelineKey': 'team-enterprise',
  '/projects/:projectKey/segments': 'team-foundation',
  '/projects/:projectKey/segments/:segmentKey': 'team-foundation',
  '/projects/:projectKey/segments/:segmentKey/flags': 'team-foundation',
  '/projects/:projectKey/segments/:segmentKey/history/:auditId/*': 'team-foundation',
  '/projects/:projectKey/segments/:segmentKey/history/*': 'team-foundation',
  '/projects/:projectKey/segments/:segmentKey/overview': 'team-foundation',
  '/projects/:projectKey/segments/:segmentKey/settings': 'team-foundation',
  '/projects/:projectKey/segments/:segmentKey/targeting': 'team-foundation',
  '/projects/:projectKey/segments/:segmentKey/targeting/exports/:exportKey': 'team-foundation',
  '/projects/:projectKey/segments/new': 'team-foundation',
  '/projects/:projectKey/sessions': 'team-o11y',
  '/projects/:projectKey/sessions/:sessionId': 'team-o11y',
  '/projects/:projectKey/settings': 'team-enterprise',
  '/projects/:projectKey/settings/approvals': 'team-enterprise',
  '/projects/:projectKey/settings/context-kinds': 'team-foundation',
  '/projects/:projectKey/settings/environments': 'team-enterprise',
  '/projects/:projectKey/settings/environments/:envKey': 'team-enterprise',
  '/projects/:projectKey/settings/environments/:envKey/approval-settings': 'team-enterprise',
  '/projects/:projectKey/settings/environments/:envKey/edit': 'team-enterprise',
  '/projects/:projectKey/settings/environments/:envKey/keys': 'team-enterprise',
  '/projects/:projectKey/settings/environments/new': 'team-enterprise',
  '/projects/:projectKey/settings/flags': 'team-enterprise',
  '/projects/:projectKey/settings/observability': 'team-o11y',
  '/projects/:projectKey/settings/observability/filter-rules/:product': 'team-o11y',
  '/projects/:projectKey/settings/payload-filters': 'team-enterprise',
  '/projects/:projectKey/settings/payload-filters/:filterKey/edit': 'team-enterprise',
  '/projects/:projectKey/settings/release-pipelines': 'team-enterprise',
  '/projects/:projectKey/settings/release-pipelines/:releasePipelineKey': 'team-enterprise',
  '/projects/:projectKey/settings/release-pipelines/new': 'team-enterprise',
  '/projects/:projectKey/settings/releases/release-pipelines': 'team-enterprise', // Updated release pipelines route
  '/projects/:projectKey/settings/releases/release-pipelines/:releasePipelineKey': 'team-enterprise', // Updated release pipelines route
  '/projects/:projectKey/settings/releases/release-pipelines/new': 'team-enterprise', // Updated release pipelines route
  '/projects/:projectKey/settings/releases': 'team-enterprise',
  '/projects/:projectKey/settings/releases/release-policies/:releasePolicyKey': 'team-guardian-releases',
  '/projects/:projectKey/settings/releases/release-policies/new': 'team-guardian-releases',
  '/projects/:projectKey/settings/releases/release-policies': 'team-guardian-releases',
  '/projects/:projectKey/traces': 'team-o11y',
  '/projects/:projectKey/vega': 'team-o11y',
  '/projects/:projectKey/vega/:conversationId': 'team-o11y',
  '/projects/:projectKey/vega/artifacts': 'team-o11y',
  '/projects/:projectKey/vega/artifacts/:type/:externalId': 'team-o11y',
  '/projects/:projectKey/vega/history': 'team-o11y',
  '/projects/:projectKey/vega/settings': 'team-o11y',
  '/settings': 'team-enterprise',
  '/settings/applications': 'team-enterprise',
  '/settings/applications/:applicationKey': 'team-enterprise',
  '/settings/applications/:applicationKey/edit': 'team-enterprise',
  '/settings/applications/:applicationKey/history/*': 'team-enterprise',
  '/settings/applications/:applicationKey/versions': 'team-enterprise',
  '/settings/applications/:applicationKey/versions/:versionKey/support-status': 'team-enterprise',
  '/settings/applications/:applicationKey/versions/new': 'team-enterprise',
  '/settings/applications/new': 'team-enterprise',
  '/settings/authorization': 'team-enterprise',
  '/settings/authorization/tokens': 'team-enterprise',
  '/settings/authorization/oauth': 'team-enterprise',
  '/settings/authorization/oauth/:appId/review': 'team-enterprise',
  '/settings/authorization/roles/:key': 'team-enterprise',
  '/settings/authorization/tokens/:tokenId/clone': 'team-enterprise',
  '/settings/authorization/tokens/:tokenId/edit': 'team-enterprise',
  '/settings/authorization/tokens/:tokenId/reset': 'team-enterprise',
  '/settings/authorization/tokens/new': 'team-enterprise',
  '/settings/billing': 'team-billing',
  '/settings/billing/plans': 'team-billing',
  '/settings/billing/plans/customize': 'team-billing',
  '/settings/billing/plans/review': 'team-billing',
  '/settings/billing/plans/confirmation': 'team-billing',
  '/settings/diagnostic-usage': 'team-billing',
  '/settings/diagnostic-usage/details/:metric': 'team-billing',
  '/settings/diagnostic-usage/details/overview': 'team-billing',
  '/settings/escalate': 'team-foundation',
  '/settings/general': 'team-enterprise',
  '/settings/history/*': 'team-enterprise',
  '/settings/integrations': 'team-agent-platform',
  '/settings/integrations/:kind/:subscriptionId/edit': 'team-agent-platform',
  '/settings/integrations/:kind/:subscriptionId/errors/view': 'team-agent-platform',
  '/settings/integrations/:kind/new': 'team-agent-platform',
  '/settings/integrations/:kind/show': 'team-agent-platform',
  '/settings/integrations/coderefs/:id/edit': 'team-agent-platform',
  '/settings/integrations/destinations/:destinationId/edit': 'team-agent-platform',
  '/settings/integrations/destinations/new': 'team-agent-platform',
  '/settings/integrations/github-app/show': 'team-guardian-releases',
  '/settings/factory': 'team-guardian-releases',
  '/settings/code-automation': 'team-guardian-releases',
  '/settings/integrations/sentry/show': 'team-agent-platform',
  '/settings/integrations/slack/:slackHookId/edit': 'team-agent-platform',
  '/settings/integrations/slack/new': 'team-agent-platform',
  '/settings/integrations/webhooks/:webhookId/edit': 'team-agent-platform',
  '/settings/integrations/webhooks/new': 'team-agent-platform',
  '/projects/:projectKey/metric-data-sources': 'team-agent-platform',
  '/projects/:projectKey/metric-data-sources/new': 'team-agent-platform',
  '/projects/:projectKey/metric-data-sources/:dataSourceKey/details': 'team-agent-platform',
  '/projects/:projectKey/data-sources': 'team-experimentation',
  '/projects/:projectKey/data-sources/metrics': 'team-experimentation',
  '/projects/:projectKey/data-sources/metrics/new': 'team-experimentation',
  '/projects/:projectKey/data-sources/metrics/:dataSourceKey': 'team-experimentation',
  '/projects/:projectKey/data-sources/metrics/:dataSourceKey/connections': 'team-experimentation',
  '/projects/:projectKey/data-sources/metrics/:dataSourceKey/connections/new-metric': 'team-experimentation',
  '/projects/:projectKey/data-sources/metrics/:dataSourceKey/configuration': 'team-experimentation',
  '/projects/:projectKey/data-sources/assignments': 'team-experimentation',
  '/projects/:projectKey/data-sources/assignments/new': 'team-experimentation',
  '/projects/:projectKey/data-sources/assignments/:dataSourceKey': 'team-experimentation',
  '/projects/:projectKey/data-sources/assignments/:dataSourceKey/connections': 'team-experimentation',
  '/projects/:projectKey/data-sources/assignments/:dataSourceKey/configuration': 'team-experimentation',
  '/settings/members': 'team-enterprise',
  '/settings/members/:memberId': 'team-enterprise',
  '/settings/members/:memberId/access-summary': 'team-enterprise',
  '/settings/members/:memberId/history/*': 'team-enterprise',
  '/settings/members/:memberId/permissions': 'team-enterprise',
  '/settings/members/:memberId/settings': 'team-enterprise',
  '/settings/members/:memberId/teams': 'team-enterprise',
  '/settings/members/invite/:inviteEmail?': 'team-enterprise',
  '/settings/plan-usage': 'team-billing',
  '/settings/plan-usage/details/overview': 'team-billing',
  '/settings/plan-usage/details/:metric': 'team-billing',
  '/settings/sdks': 'team-billing',
  '/settings/sdks/:applicationId': 'team-billing',
  '/settings/token-limits': 'team-ai-agents',
  '/settings/profile': 'team-enterprise',
  '/settings/projects': 'team-enterprise',
  '/settings/relay': 'team-enterprise',
  '/settings/relay/:id/edit': 'team-enterprise',
  '/settings/relay/new': 'team-enterprise',
  '/settings/roles': 'team-enterprise',
  '/settings/roles/project': 'team-enterprise',
  '/settings/roles/organization': 'team-enterprise',
  '/settings/roles/project/:key/view': 'team-enterprise',
  '/settings/roles/organization/:key/view': 'team-enterprise',
  '/settings/roles/:key/edit': 'team-enterprise',
  '/settings/roles/:key/view': 'team-enterprise',
  '/settings/roles/new': 'team-enterprise',
  '/settings/security': 'team-billing',
  '/settings/security/saml/config': 'team-billing',
  '/settings/teams': 'team-enterprise',
  '/settings/teams/:teamKey': 'team-enterprise',
  '/settings/teams/:teamKey/access-summary': 'team-enterprise',
  '/settings/teams/:teamKey/history/*': 'team-enterprise',
  '/settings/teams/:teamKey/members': 'team-enterprise',
  '/settings/teams/:teamKey/permissions': 'team-enterprise',
  '/settings/teams/:teamKey/settings': 'team-enterprise',
  '/settings/tokens/*': 'team-enterprise',
  '/settings/usage': 'team-billing',
  '/settings/usage/details/*': 'team-billing',
  '/settings/sdk-keys': 'team-enterprise',
  '/verify-email': 'team-enterprise',
  '/welcome-survey': 'team-foundation',
  '/confirm-your-email': 'team-enterprise',
  '/projects/:projectKey/product-analytics': 'team-product-analytics',
  '/projects/:projectKey/product-analytics/events': 'team-product-analytics',
  '/projects/:projectKey/product-analytics/cohorts': 'team-product-analytics',
  '/projects/:projectKey/product-analytics/cohorts/:id': 'team-product-analytics',
  '/projects/:projectKey/product-analytics/cohorts/:id/edit': 'team-product-analytics',
  '/projects/:projectKey/product-analytics/cohorts/new': 'team-product-analytics',
  '/projects/:projectKey/product-analytics/user-attributes': 'team-product-analytics',
  '/projects/:projectKey/product-analytics/user-activity': 'team-product-analytics',
  '/projects/:projectKey/product-analytics/dashboards': 'team-product-analytics',
  '/projects/:projectKey/product-analytics/dashboards/new': 'team-product-analytics',
  '/projects/:projectKey/product-analytics/dashboards/:id': 'team-product-analytics',
  '/projects/:projectKey/product-analytics/charts/:id': 'team-product-analytics',
  '/projects/:projectKey/product-analytics/charts/new': 'team-product-analytics',
  '/projects/:projectKey/product-analytics/charts': 'team-product-analytics',
  '/projects/:projectKey/product-analytics/visualizations/:id': 'team-product-analytics',
  '/projects/:projectKey/product-analytics/visualizations/new': 'team-product-analytics',
  '/projects/:projectKey/settings/views': 'team-enterprise',
  '/projects/:projectKey/settings/views/settings': 'team-enterprise',
  '/projects/:projectKey/settings/views/new': 'team-enterprise',
  '/projects/:projectKey/settings/views/:viewKey': 'team-enterprise',
  // ":viewKey/link" to be removed after phase 2 of views project
  '/projects/:projectKey/settings/views/:viewKey/link': 'team-enterprise',
  '/projects/:projectKey/settings/views/:viewKey/linked-resources': 'team-enterprise',
  '/projects/:projectKey/settings/views/:viewKey/linked-resources/:resource': 'team-enterprise',
  '/projects/:projectKey/settings/views/:viewKey/linked-resources/:resource/add': 'team-enterprise',
  '/projects/:projectKey/settings/views/:viewKey/application': 'team-enterprise',
  '/projects/:projectKey/settings/views/:viewKey/settings': 'team-enterprise',
  '/projects/:projectKey/settings/lifecycle': 'team-enterprise',
  '/projects/:projectKey/settings/vega': 'team-o11y',
};
